module.exports = __webpack_public_path__ + "img/yancao_chengcheng_suoluetu.3ed36909.png";